@if (!loading) {
  <div class="agenda-calendar cbw-agenda-calendar cbw-pre-defined-slot-list">
    <div class="agenda-calendar-header cbw-agenda-calendar-header">
      <div
        class="btn"
        [ngClass]="{ 'disabled': selectedYear <= currentYear }"
        (click)="getPreviousYearSlots()"
      >
        <div class="prev-arrow-container">
          <fa-icon class="icon cbw-prev-arrow-button d-flex" icon="chevron-left" />
        </div>
      </div>
      <div class="year">{{ selectedYear }}</div>
      <div
        class="btn"
        [ngClass]="{ 'disabled': selectedYear >= maxYear }"
        (click)="getNextYearSlots()"
      >
        <div class="next-arrow-container">
          <fa-icon class="icon cbw-next-arrow-button d-flex" icon="chevron-right" />
        </div>
      </div>
    </div>
    <div class="agenda-calendar-months-wrapper cbw-agenda-calendar-months-wrapper">
      <div class="agenda-calendar-months cbw-agenda-calendar-months">
        @for (month of monthsConst | keepOrderKeyvalue; track month.key; let index = $index) {
          <div
            class="month"
            [ngClass]="{
              'active': month.key === selectedMonth,
              'disabled': !_filteredSlots[month.key]
            }"
            (click)="_filteredSlots[month.key] && filterWithMonth(month.key)"
          >{{ 'shortMonths.' + month.value | translate }}</div>
        }
      </div>
    </div>
    <div class="agenda-slots cbw-agenda-slots">
      @if (hasNoSlots()) {
        <div role="alert" class="no-bookable-error-message alert alert-warning cbw-agenda-no-bookable-error-message">
          {{ 'pre_defined_slots.no_slots_available' | translate }}
        </div>
      } @else {
        @for (months of _filteredSlots | keepOrderKeyvalue; track $index) {
          <div>
            @if (!selectedMonth) {
              <div class="agenda-month-title cbw-agenda-month-title">{{ monthsConst[months.key] | translate }}</div>
            }
            @if ((selectedMonth === months.key) || !selectedMonth) {
              @for (dates of months.value | keepOrderKeyvalue; track $index) {
                <div class="agenda-date-title cbw-agenda-date-title">{{ dates.key | date: dateFormat }}</div>
                <div class="agenda-slot cbw-agenda-slot">
                  @for (slot of dates.value; track slot.uuid) {
                    <ng-container *ngTemplateOutlet="slotCard; context: { $implicit: slot }" />
                  }
                </div>
              }
            }
          </div>
        }
      }
    </div>
  </div>
} @else {
  <ng-container *ngTemplateOutlet="agendaSkeleton" />
}

<ng-template #slotCard let-slot>
  <div
    class="slot-card cbw-pre-defined-slot-card"
    [ngClass]="{ 'selected': isSlotSelected(slot.uuid) }"
    (click)="onSelectSlot(slot)"
    role="button"
    tabindex="0"
    (keydown.enter)="onSelectSlot(slot)"
    (keydown.space)="onSelectSlot(slot)"
  >
    <div class="slot-card-content">
      @if (slot.title) {
        <div class="slot-title">{{ slot.title }}</div>
      }
      <div class="slot-time">
        {{ slot.start_utc | date: timeFormat }} - {{ slot.end_utc | date: timeFormat }}
      </div>
      @if (slot.appointment_service) {
        <div class="slot-service">{{ slot.appointment_service | translation: 'name': lang }}</div>
      }
      @if (slot.location) {
        <div class="slot-location">
          <fa-icon icon="map-marker-alt" class="me-1" />
          {{ slot.location }}
        </div>
      }
    </div>
    <div class="next-arrow-container">
      @if (isSlotSelected(slot.uuid)) {
        <span (click)="$event.stopPropagation(); nextClicked.emit()">
          <fa-icon class="icon cbw-next-arrow-button d-flex" icon="chevron-circle-right" />
        </span>
      }
    </div>
  </div>
</ng-template>

<ng-template #agendaSkeleton>
  <div class="agenda-calendar-ghost cbw-agenda-calendar-ghost shadow">
    <div class="skeleton-animation">
      <div class="agenda-calendar-header cbw-agenda-calendar-header">
        <div class="btn disabled">
          <div class="prev-arrow-container">
            <fa-icon class="icon cbw-prev-arrow-button d-flex" icon="chevron-left" />
          </div>
        </div>
        <div class="bar year-title"></div>
        <div class="btn disabled">
          <div class="next-arrow-container">
            <fa-icon class="icon cbw-next-arrow-button d-flex" icon="chevron-right" />
          </div>
        </div>
      </div>

      <div class="agenda-calendar-months-wrapper cbw-agenda-calendar-months-wrapper">
        @for (month of skeletonMonths; track $index) {
          <div class="bar month"></div>
        }
      </div>

      <div class="agenda-slots cbw-agenda-slots">
        @for (item of skeletonSlots; track $index) {
          <div>
            <div class="bar date"></div>
            <div class="slots">
              @for (slot of [0, 1, 2]; track slot) {
                <div class="bar slot"></div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>
